import React from 'react';
import * as styles from './Card.style';
import CardText from './text/CardText';
import CardTitle from './title/CardTitle';

export type CardProps = React.PropsWithChildren<{}>;

interface CardComposition {
  Title: typeof CardTitle,
  Text: typeof CardText,
}

const Card: React.FC<CardProps> & CardComposition = ({
  children,
  ...rest
}) => (
  <div
    {...rest}
    css={styles.base}
  >
    {children}
  </div>
);

Card.Title = CardTitle;
Card.Text = CardText;

export default Card;
